import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { showNotification } from '@epi-actions/overlays';
import emptyApi from '@epi-api/emptyApi';
import { get } from '@epi-helpers/FetchHelpers';

import config from '@epi-config';
import {
  BenefitGroupSettingsResponse,
  IBenefitGroupSettings
} from '@epi-models/pages/Beneficiaries';

export const USER_API_URL = `${config.apiHost}/api/user`;
export const IMPERSONATION_API_URL = `${config.apiHost}/api/admin-tool/impersonation/token`;

export const getBenefitSettingsGroupSettings =
  async (): Promise<BenefitGroupSettingsResponse> =>
    get<BenefitGroupSettingsResponse>(
      `${config.apiHost}/api/benefit-group-settings`
    );

export const settingsApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    getBenefitSettingsGroupSettings: build.query<
      IBenefitGroupSettings[] | [],
      void
    >({
      async queryFn(_arg, api) {
        try {
          const data = await getBenefitSettingsGroupSettings();
          return { data: data?.benefitGroupSettings ?? [] };
        } catch (error) {
          api.dispatch(
            showNotification({ message: 'messages.error' }, 'error')
          );
          return { error: error as FetchBaseQueryError };
        }
      },
      keepUnusedDataFor: 1800
    })
  })
});

export const {
  useGetBenefitSettingsGroupSettingsQuery,
  useLazyGetBenefitSettingsGroupSettingsQuery
} = settingsApi;
